import React, { useState } from 'react';
import { ViewContext } from './ViewContext';

const ViewState = props => {
	const [rowViews, setRowViews] = useState({
		clusterHierarchy: true,
		users: true,
		applications: true,
		logarithmicFeatures: true,
		ratioFeatures: true,
		scatterPlots: true
	});
	const [hiPlotModal, setHiPlotModal] = React.useState(false);
	const [yAxisCoordinates, setYAxisCoordinates] = React.useState('per-column');
	const [hiPlotValues, setHiPlotValues] = React.useState([
		'POSIX_TOTAL_BYTES',
		'POSIX_TOTAL_ACCESSES',
		'POSIX_TOTAL_FILES',
		'RUNTIME',
		'NPROCS',
		'POSIX_READS_PERC',
		'POSIX_AGG_PERF_BY_SLOWEST',
		'users',
		'apps_short'
	]);
	return (
		<ViewContext.Provider
			value={{
				views: rowViews,
				hiPlotModal: hiPlotModal,
				yAxisCoordinates: yAxisCoordinates,
				toggleViews: row => {
					setRowViews({
						...rowViews,
						[row]: !rowViews[row]
					});
				},
				hiPlotValues: hiPlotValues,
				setHiPlotModal: setHiPlotModal,
				setYAxisCoordinates: axis => {
					setYAxisCoordinates(axis);
				},
				setHiPlotValues: e => {
					if (hiPlotValues.includes(e.target.name)) {
						const filtered = hiPlotValues.filter(
							check => check !== e.target.name
						);
						setHiPlotValues(filtered);
					} else {
						setHiPlotValues(hiPlotValues => [...hiPlotValues, e.target.name]);
					}
				}
			}}
		>
			{props.children}
		</ViewContext.Provider>
	);
};

export default ViewState;
